import useApi from '../api';

const useDashboardCheckAgroService = () => {
    const { api } = useApi();

    return {
        getDashboardCheckAgro: (enterpriseId, year) =>
            api.get(`enterprise/${enterpriseId}/get_check_agro_details`, {
                params: {
                    year
                }
            })
    };
};

export default useDashboardCheckAgroService;
